export default {"src":"/_next/static/media/logo.9c570ac9.svg","height":28,"width":220,"blurWidth":0,"blurHeight":0};